<template>
  <div v-if="survey">
    <edit-survey-initial-data-form v-model="survey" read-only class="mt-3" @submit="onSubmit" />
    <edit-survey-form v-model="survey" read-only class="mt-3" @submit="onSubmit" />
  </div>
</template>

<script>
// Components
import EditSurveyInitialDataForm from '@/components/forms/EditSurveyInitialDataForm.vue'
import EditSurveyForm from '@/components/forms/EditSurveyForm.vue'

// Store
import { mapState } from 'vuex'

// Component
export default {
  components: {
    EditSurveyForm,
    EditSurveyInitialDataForm,
  },
  props: {},
  data() {
    return {
      counters: ['owned', 'leasing', 'rent'],
      items: ['vehicles', 'tractors', 'trailers', 'semitrailers'],
      labels: {
        owned: 'Proprietà',
        leasing: 'Leasing',
        rent: 'Locazione',
        vehicles: 'Nr. Automezzi con portata utile ≥ 35q',
        tractors: 'Nr. Trattori stradali',
        trailers: 'Nr. Rimorchi',
        semitrailers: 'Nr. Semirimorchi',
      },
      ownershipReasons: {
        1: 'Venduto',
        2: 'Ceduto',
        3: 'Locato',
        4: 'Rottamato',
        5: 'Sequestrato',
        6: 'Rubato',
      },
    }
  },
  computed: {
    ...mapState('survey', ['survey']),
    targa() {
      return this.survey?.targa ?? ''
    },
    owner() {
      return this.survey.owner
    },
    referent() {
      return this.survey.referent
    },
    fleet() {
      return this.survey.fleet
    },
    vehicle() {
      return this.survey.vehicle
    },
    ownership() {
      return this.vehicle.ownership
    },
    ownershipText() {
      if (this.ownership.changed) {
        const { reason, date } = this.ownership
        return `${this.ownershipReasons[reason]} in data ${date}`
      }
      return 'Di proprietà'
    },
    activity() {
      return this.vehicle.activity
    },
    activityText() {
      if (this.activity.stopped) {
        return 'Fermo'
      }
      return 'Di proprietà'
    },
  },
  methods: {
    async onSubmit(data) {
      await this.$store.dispatch('surveys/update', { id: this.survey.id, data })
    },
  },
}
</script>

<style lang="scss" scoped></style>
